import React, { useState, useEffect, Fragment } from 'react';
// import { Deck, Slide } from 'spectacle';
import styled, { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import theme from './theme';
import { mergeTheme, oneTheme } from './deckTheme';

import VocationJuniorLogoWhite from './imgs/vocation_junior_logo_white2x.png';
import EdumetricsLogo from './imgs/edumetrics_logo.png';
import MapaOrientacion from './imgs/mapa-orientacion-carreras_updated.png';
import InteresesJunior from './imgs/junior_model.png';
// import EnfoqueImg from './imgs/enfoque_estudios.png';
import AproximaEstudioModel from './imgs/aproximacion_estudio_model.png';

import {
  ResetCSS,
  GlobalStyle,
  PageWrapper,
  PageNumber,
  ArasDetailsBackLayer
} from './styles';
// pages
// import WaffleChart from './WaffleChart';
import GradeDistributionChart from './GradeDistributionChart';
import AreasStackedChart from './AreasStackedChart';

import ABCStackedChart from './ABCStackedChart';
import DisciplinesTopStackedChart from './DisciplinesTopStackedChart';
import ProgressPieChart from './ProgressPieChart';
import Icon02 from './imgs/icons/edu_iconos_6.svg';
import Icon03 from './imgs/icons/edu_iconos_3.svg';
import Icon05 from './imgs/icons/edu_iconos_5.svg';
import Icon07 from './imgs/icons/edu_iconos_7.svg';

const Deck = props => {
  const style = {
    position: 'relative',
    height: `${props.theme.size.height}px`,
    width: `${props.theme.size.width}px`,
    backgroundColor: props.backgroundColor || '#FFFFFF',
    page: 'report' // css page definition
  };
  return <div style={style}>{props.children}</div>;
};

const Slide = props => {
  const style = {
    position: 'relative',
    height: `100%`,
    width: `100%`,
    backgroundColor: props.backgroundColor || 'transparent'
  };
  return (
    <div className='page' id='report' style={style}>
      {props.children}
    </div>
  );
};

export const ChartWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: ${({ height }) => (height ? height : 400)}px;
  width: 100%;
`;

// Slider Deck theme
const deckTheme = mergeTheme(oneTheme);

// https://github.com/FormidableLabs/spectacle/blob/master/docs/content/advanced-concepts.md#query-parameters
// add to url
// &exportMode=true
export const SlidePage = ({
  number,
  children,
  background,
  isFullCover,
  ...rest
}) => {
  // const isEven = number % 2 === 0;
  // console.log({ number, isEven });
  return (
    <PageWrapper {...rest} backgroundImage={background}>
      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 45,
          left: 25
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon02}
          alt='edumetrics vocation start logo'
          style={{
            width: 200,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 200,
          // top: 285,
          left: isFullCover ? 150 : 400
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon07}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 250 : 185,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: isFullCover ? 100 : 250,
          right: isFullCover ? 100 : 460
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon03}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 300 : 225,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: isFullCover ? 0 : -50,
          // top: 225,
          right: isFullCover ? 150 : 250
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon05}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 275 : 225,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      {children}
      {number && <PageNumber>{number}</PageNumber>}
    </PageWrapper>
  );
};
// caso real
// /c/9f01895a-1701-445d-bfe4-673b80a8932d/Ab7JsNgMspCwrJv-yYv5m
// /r/a14c8d54-4bf9-4a27-bfe3-892c3d6ac6e3?exportMode=true
// /c/7f4fda3a-0394-4677-8be8-a1f72930b388/k1_QPEIBj4LxMnr99e5li?exportMode=true

// diego Prueba
// /c/a499adf2-1560-49f2-ba51-450e5f639bee
// /r/84af0b5d-5ced-44c5-acda-bd71ae233972?exportMode=true

const SlideHeader = ({ campaign }) => {
  const campaignLogo = campaign?.metadata?.logo ? campaign.metadata.logo : null;
  return (
    <div className='slide-header'>
      {campaignLogo && (
        <div className='logo'>
          <img
            src={campaignLogo}
            alt={`${campaign.organization || 'campaign'} logo`}
          />
        </div>
      )}
      <div className='logo'>
        <img src={EdumetricsLogo} alt='edumetrics logo' />
      </div>
      {/* <div className='logo'>
      <img src={ABLogo} alt='Albert Bridge logo' />
    </div> */}
    </div>
  );
};

const PlainHeader = () => (
  <div className='plain-header right'>
    <div className='logo-big'>
      <img src={VocationJuniorLogoWhite} alt='vocation-junior logo' />
    </div>
  </div>
);

const VocationJunior = ({ campaign, responses }) => {
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(false);
  // const [user, setUser] = useState(null);
  const [campaignData, setCampaignData] = useState(null);
  // console.log({ props });
  // console.log({ campaign, responses });

  useEffect(() => {
    // console.log({ params });
    const parseCampaign = async () => {
      const male = responses.filter(resp => resp.data.SEX === 'Masculino');
      const female = responses.filter(resp => resp.data.SEX === 'Femenino');
      const grades = [...new Set(responses.map(resp => resp.data.grade))]
        .sort((a, b) => a.localeCompare(b))
        .filter(Boolean); // clean undefined and falsy grades (with no list)
      const gradeResponses = grades.map(grade => {
        return {
          grade,
          responses: responses.filter(resp => resp.data.grade === grade)
        };
      });
      console.log({ gradeResponses });
      const infoData = { grades, male, female, gradeResponses };
      setCampaignData(infoData);
      setLoading(false);
    };
    parseCampaign();
  }, [campaign, responses]);

  // console.log({ user });
  if (loading) {
    return <div>loading...</div>;
  }
  console.log({ campaignData });

  const firstStep = 6;
  const gradesLength = campaignData?.grades.length;
  const hasGrades = gradesLength > 1;
  const secondStep = hasGrades
    ? firstStep + gradesLength
    : firstStep - gradesLength;
  const thirdStep = hasGrades ? secondStep + gradesLength + 7 : secondStep + 7;
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Helmet>
          <title>{`${(campaign.organization || campaign.title)
            .split(' ')
            .join('_')}_VocationJunior_${campaign.id}`}</title>
        </Helmet>
        <ResetCSS />
        <GlobalStyle />
        <Deck theme={deckTheme} backgroundColor='#5ea763'>
          <Slide backgroundColor='#5ea763'>
            <SlidePage isFullCover>
              {campaign?.metadata?.logo && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={campaign.metadata.logo}
                    alt={`${campaign.organization || 'campaign'} logo`}
                    style={{
                      maxWidth: 250,
                      height: 100,
                      display: 'block',
                      objectFit: 'contain',
                      marginTop: 48
                    }}
                  />
                </div>
              )}
              <div className='title-page'>
                <div className='logo-big'>
                  <img
                    src={VocationJuniorLogoWhite}
                    alt='vocation-junior logo'
                  />
                </div>
              </div>
              <div
                className='top-body'
                style={{ paddingLeft: '5rem', paddingRight: '5rem' }}
              >
                <h1>Presentación de Resultados</h1>
                <h2>{campaign.organization || campaign.title}</h2>
              </div>
            </SlidePage>
          </Slide>

          {/** BLANK PAGE */}
          <Slide backgroundColor='#5ea763'>
            <SlidePage isFullCover></SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={1}>
              <SlideHeader campaign={campaign} />
              <div className='half-left'>
                <div>
                  <h1>
                    <span>¿</span>Qué es{' '}
                    <span>
                      <img
                        src={VocationJuniorLogoWhite}
                        style={{ marginLeft: '1rem' }}
                        alt='vocation-junior logo'
                      />
                    </span>
                    <span>?</span>
                  </h1>
                </div>
              </div>
              <div className='slide-body right'>
                <div className='slide-content'>
                  <div className='flex-center'>
                    <p>
                      <strong>Vocation Junior</strong> es un test de orientación
                      sobre preferencias e intereses vocacionales a profundizar
                      en los últimos años de la etapa escolar para estudiantes
                      de enseñanza media, diseñado por Edumetrics.
                      <br />
                      <br />
                      Desarrollado para identificar asignaturas de
                      profundización para estudiantes de Iº y II° Medio, incluye
                      también un test de acercamiento a Preferencias
                      Vocacionales Iniciales, junto a un assessment de
                      Aproximaciones al Aprendizaje para entender el valor que
                      los y las estudiantes le otorgan al aprendizaje y sus
                      estrategias de estudio predominantes.
                    </p>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={2}>
              <SlideHeader campaign={campaign} />
              <div className='half-left'>
                <div>
                  <h1>
                    <span>¿</span>Qué es{' '}
                    <span>
                      <img
                        src={VocationJuniorLogoWhite}
                        style={{ marginLeft: '1rem' }}
                        alt='vocation-junior logo'
                      />
                    </span>
                    <span>?</span>
                  </h1>
                </div>
              </div>
              <div className='slide-body right'>
                <div className='slide-content'>
                  <h1>Objetivo</h1>
                  <div>
                    <ul>
                      <li>
                        Orientar a estudiantes respecto de sus preferencias para
                        seleccionar las asignaturas de profundización que
                        deberán cursar en 3ero y 4to medio.
                      </li>
                      <li>
                        Entregar información sobre sus principales motivaciones
                        y estrategias de estudio.
                      </li>
                      <li>
                        Entregar información a los establecimientos sobre las
                        preferencias de sus estudiantes, para decidir qué cursos
                        optativos ofrecer cada año.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {/* <Slide backgroundColor='#5ea763'>
            <SlidePage number={3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Distribución de estudiantes participantes</h1>
                </div>
                <div className='footnote'>
                  <div>Número de hombres y mujeres</div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General</h1>
                  <p>
                    Total = {responses.length} (Mujeres ={' '}
                    {campaignData?.female.length}; Hombres ={' '}
                    {campaignData?.male.length})
                  </p>
                  <div>
                    <br />
                    <ChartWrapper height={600}>
                      <WaffleChart responses={responses} />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide> */}

          {hasGrades ? (
            <Slide backgroundColor='#5ea763'>
              <SlidePage number={3}>
                <SlideHeader campaign={campaign} />
                <div className='third-left'>
                  <div>
                    <h1>Distribución de estudiantes participantes</h1>
                  </div>
                  <div className='footnote'>
                    <div>Número de participantes por curso</div>
                  </div>
                </div>
                <div className='slide-body big'>
                  <div className='slide-content'>
                    <h1>Distribución Detallada</h1>
                    <p style={{ fontSize: '1.5rem' }}>
                      <strong>Total</strong> = {responses.length} participantes.{' '}
                      {'('}
                      {campaignData?.gradeResponses.map((g, idx) => {
                        const isLast =
                          idx === campaignData.gradeResponses.length - 1;
                        return (
                          <Fragment key={`${g.grade}_${idx.toString()}_resp`}>
                            <strong>{g.grade}</strong>
                            {' = '}
                            <span>{g.responses.length}</span>
                            {isLast ? '' : '; '}
                          </Fragment>
                        );
                      })}
                      {')'}
                    </p>
                    <div>
                      <br />
                      <ChartWrapper height={600}>
                        <GradeDistributionChart
                          grades={campaignData?.gradeResponses}
                        />
                      </ChartWrapper>
                    </div>
                  </div>
                </div>
              </SlidePage>
            </Slide>
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={hasGrades ? 4 : 3}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Orientación Vocacional</h1>
                <h2>Preferencias Principales</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={hasGrades ? 5 : 4}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Preferencias Principales</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <p>
                      Como un acercamiento inicial a los intereses vocacionales,
                      el Test Vocation Junior identifica las preferencias
                      vocacionales de los y las estudiantes en base a un modelo
                      circular de 8 áreas principales. El propósito es que cada
                      estudiante pueda comenzar a reflexionar sobre sus
                      intereses vocacionales iniciales, como parte del proceso
                      de elección de asignaturas de profundización.
                    </p>
                  </div>
                  <div
                    className='image-wrapper'
                    style={{ position: 'relative' }}
                  >
                    <img
                      style={{ height: 685, marginTop: -48 }}
                      src={MapaOrientacion}
                      alt='modelo-vocacional'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={hasGrades ? 6 : 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Preferencias Principales</h1>
                  <h2>Distribución General</h2>
                  {!hasGrades && (
                    <p style={{ fontSize: '1.85rem', color: '#ffffff' }}>
                      <strong>Total</strong> = {responses.length} participantes.
                    </p>
                  )}
                </div>
                <div className='footnote'>
                  <div>
                    Número de estudiantes agrupados según su nivel de interés en
                    las distintas preferencias principales
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <AreasStackedChart responses={responses} />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData?.gradeResponses.map((grade, index) => (
              <Slide backgroundColor='#5ea763' key={`areas${grade.grade}`}>
                <SlidePage number={firstStep + index + 1}>
                  <SlideHeader campaign={campaign} />
                  <div className='third-left'>
                    <div>
                      <h1>Preferencias Principales</h1>
                      <h2>Distribución {grade.grade}</h2>
                    </div>
                    <div className='footnote'>
                      <div>
                        Número de estudiantes de curso {grade.grade} agrupados
                        según su nivel de interés en las distintas áreas
                        principales
                      </div>
                    </div>
                  </div>
                  <div className='slide-body big'>
                    <div className='slide-content'>
                      <h1>Distribución {grade.grade}</h1>
                      <div>
                        <ChartWrapper height={700}>
                          <AreasStackedChart responses={grade.responses} />
                        </ChartWrapper>
                      </div>
                    </div>
                  </div>
                </SlidePage>
              </Slide>
            ))
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 1}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Orientación Vocacional</h1>
                <h2>Áreas Disciplinares</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Áreas Disciplinares</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <p>
                      El Test Vocation Junior identifica aquellas áreas
                      disciplinares de interés de cada estudiante, es decir,
                      aquellas áreas del saber en qué les interesaría
                      profundizar más en su última etapa escolar. El test
                      Vocation Junior identifica tres grandes áreas de interés,
                      A, B y C, y nueve disciplinas:
                    </p>
                  </div>
                  <div className='image-wrapper'>
                    <img
                      style={{ height: 650, marginTop: -6 }}
                      src={InteresesJunior}
                      alt='dsa'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {/* <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Áreas Disciplinares</h1>
                  <h2>Distribución General</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <ABCStackedChart
                        gradesResponses={campaignData?.gradeResponses}
                        responses={responses}
                        user={user}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide> */}

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Áreas Disciplinares</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Grado de interés promedio por area A, B y C (0% = ningún
                    interés; 100% = máximo interés).
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <ABCStackedChart
                        gradesResponses={campaignData?.gradeResponses}
                        responses={responses}
                        // user={user}
                        groupMode='grouped'
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>
          {/*
          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Áreas Disciplinares</h1>
                  <h2>Distribución General (3)</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General (3)</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <ABCDivergentChart
                        gradesResponses={campaignData?.gradeResponses}
                        responses={responses}
                        user={user}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide> */}

          {/*
          <Slide backgroundColor='#5ea763'>
            <SlidePage number={4}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Áreas Disciplinares</h1>
                  <h2>Distribución 2do A</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución 2do A</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <PieChart user={user} />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide> */}

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 4}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Orientación Vocacional</h1>
                <h2>Disciplinas de Interés</h2>
              </div>
            </SlidePage>
          </Slide>

          {/**
          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Disciplinas de Interés</h1>
                  <h2>Distribución General</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <ArasDetailsBackLayer>
                        <div className="area-back area-a"><div className="label">A</div></div>
                        <div className="area-back area-b"><div className="label">B</div></div>
                        <div className="area-back area-c"><div className="label">C</div></div>
                      </ArasDetailsBackLayer>
                      <DisciplinesStackedChart
                        responses={responses}
                        user={user}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>
 */}

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Disciplinas de Interés</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Número de estudiantes que seleccionan cada disciplina de
                    interés en primera prioridad.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General (1ra prioridad)</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <ArasDetailsBackLayer>
                        <div className='area-back area-a'>
                          <div className='label'>A</div>
                        </div>
                        <div className='area-back area-b'>
                          <div className='label'>B</div>
                        </div>
                        <div className='area-back area-c'>
                          <div className='label'>C</div>
                        </div>
                      </ArasDetailsBackLayer>
                      <DisciplinesTopStackedChart
                        responses={responses}
                        // user={user}
                        // dimensions={['F', 'HGC', 'LL']}
                        prioridades={['1ra Prior.']}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 6}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Disciplinas de Interés</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Número de estudiantes que seleccionan cada disciplina de
                    interés en primera, segunda, tercera y cuarta prioridad.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General (Prioridades)</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <ArasDetailsBackLayer>
                        <div className='area-back area-a'>
                          <div className='label'>A</div>
                        </div>
                        <div className='area-back area-b'>
                          <div className='label'>B</div>
                        </div>
                        <div className='area-back area-c'>
                          <div className='label'>C</div>
                        </div>
                      </ArasDetailsBackLayer>
                      <DisciplinesTopStackedChart responses={responses} />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {/**
          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Disciplinas de Interés</h1>
                  <h2>Distribución General</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General A</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <DisciplinesTopStackedChart
                        responses={responses}
                        user={user}
                        dimensions={['F', 'HGC', 'LL']}
                        prioridades={['1ra Prior.']}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>
 */}

          {/**
          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Disciplinas de Interés</h1>
                  <h2>Distribución General</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General B</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <DisciplinesTopStackedChart
                        responses={responses}
                        user={user}
                        dimensions={['CBS', 'CD', 'M']}
                        prioridades={['1ra Prior.']}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>
 */}

          {/**

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={secondStep + 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Disciplinas de Interés</h1>
                  <h2>Distribución General</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Distribución General C</h1>
                  <div>
                    <ChartWrapper height={700}>
                      <DisciplinesTopStackedChart
                        responses={responses}
                        user={user}
                        dimensions={['AV', 'AI', 'D']}
                        prioridades={['1ra Prior.']}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>
 */}

          {hasGrades ? (
            campaignData?.gradeResponses.map((grade, index) => (
              <Slide backgroundColor='#5ea763' key={`disc${grade.grade}`}>
                <SlidePage number={secondStep + index + 7}>
                  <SlideHeader campaign={campaign} />
                  <div className='third-left'>
                    <div>
                      <h1>Disciplinas de Interés</h1>
                      <h2>Prioridades {grade.grade}</h2>
                    </div>
                    <div className='footnote'>
                      <div>
                        Número de estudiantes {grade.grade} que seleccionan cada
                        disciplina de interés en primera, segunda, tercera y
                        cuarta prioridad
                      </div>
                    </div>
                  </div>
                  <div className='slide-body big'>
                    <div className='slide-content'>
                      <h1>Distribución {grade.grade} (Prioridades)</h1>
                      {/**
                    <div>
                      <ChartWrapper height={700}>
                        <DisciplinesStackedChart responses={grade.responses} />
                      </ChartWrapper>
                    </div>
                     */}

                      <div>
                        <ChartWrapper height={700}>
                          <ArasDetailsBackLayer>
                            <div className='area-back area-a'>
                              <div className='label'>A</div>
                            </div>
                            <div className='area-back area-b'>
                              <div className='label'>B</div>
                            </div>
                            <div className='area-back area-c'>
                              <div className='label'>C</div>
                            </div>
                          </ArasDetailsBackLayer>
                          <DisciplinesTopStackedChart
                            responses={grade.responses}
                          />
                        </ChartWrapper>
                      </div>
                    </div>
                  </div>
                </SlidePage>
              </Slide>
            ))
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={thirdStep}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Orientación Vocacional</h1>
                <h2>Aproximación al estudio</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={thirdStep + 1}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Aproximación al estudio</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <p>
                      El Test Vocation Junior describe el enfoque de estudio de
                      los/las estudiantes, identificando sus principales
                      motivaciones para estudiar y aprender, así como las
                      principales estrategias que utilizan en sus estudios.
                    </p>
                  </div>
                  <div className='image-wrapper'>
                    <img
                      style={{ height: 650 }}
                      src={AproximaEstudioModel}
                      alt='dsa'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={thirdStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Aproximación al estudio</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Porcentaje de estudiantes que tienen un puntaje ALTO y BAJO
                    en cada una de las Orientaciones al Aprendizaje.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Orientaciones al Aprendizaje</h1>
                  <div className='scale-grid cols-2'>
                    <div className='scale-wrap'>
                      <h3>Orientación al aprendizaje profundo</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='MA' responses={responses} />
                      </ChartWrapper>
                    </div>
                    <div className='scale-wrap'>
                      <h3>Orientación al aprendizaje instrumental</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='MS' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                  <div className='scale-grid'>
                    <div className='scale-wrap'>
                      <h3>Orientación de logro académico</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='ML' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#5ea763'>
            <SlidePage number={thirdStep + 3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Aproximación al estudio</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Porcentaje de estudiantes que tienen un puntaje ALTO y BAJO
                    en cada una de las Estrategias de Estudio.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1>Estrategias de Estudio</h1>
                  <div className='scale-grid cols-2'>
                    <div className='scale-wrap'>
                      <h3>Estrategias de aprendizaje profundo</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='AP' responses={responses} />
                      </ChartWrapper>
                    </div>
                    <div className='scale-wrap'>
                      <h3>Estrategias de aprendizaje instrumental</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='ES' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                  <div className='scale-grid'>
                    <div className='scale-wrap'>
                      <h3>Estrategias de logro académico</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='EL' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData?.grades
              .map(grade => [grade, grade])
              .flat()
              .map((grade, index) => {
                const gradeData = campaignData.gradeResponses.find(
                  g => g.grade === grade
                );
                const isEven = index % 2 === 0;
                return (
                  <Slide
                    backgroundColor='#5ea763'
                    key={`study${grade.grade}_${index}`}
                  >
                    <SlidePage number={thirdStep + 4 + index}>
                      <SlideHeader campaign={campaign} />
                      <div className='third-left'>
                        <div>
                          <h1>Aproximación al estudio</h1>
                          <h2>Distribución {gradeData.grade}</h2>
                        </div>
                        <div className='footnote'>
                          <div>
                            Porcentaje de estudiantes {gradeData.grade} que
                            tienen un puntaje ALTO y BAJO en cada una de las{' '}
                            {isEven
                              ? 'Orientaciones al Aprendizaje'
                              : 'Estrategias de Estudio'}
                          </div>
                        </div>
                      </div>
                      {isEven ? (
                        <div className='slide-body big'>
                          <div className='slide-content'>
                            <h1>
                              Orientaciones al Aprendizaje {gradeData.grade}
                            </h1>
                            <div className='scale-grid cols-2'>
                              <div className='scale-wrap'>
                                <h3>Orientación al aprendizaje profundo</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='MA'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                              <div className='scale-wrap'>
                                <h3>Orientación al aprendizaje instrumental</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='MS'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                            <div className='scale-grid'>
                              <div className='scale-wrap'>
                                <h3>Orientación de logro académico</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='ML'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className='slide-body big'>
                          <div className='slide-content'>
                            <h1>Estrategias de Estudio {gradeData.grade}</h1>
                            <div className='scale-grid cols-2'>
                              <div className='scale-wrap'>
                                <h3>Estrategias de aprendizaje profundo</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='AP'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                              <div className='scale-wrap'>
                                <h3>Estrategias de aprendizaje instrumental</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='ES'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                            <div className='scale-grid'>
                              <div className='scale-wrap'>
                                <h3>Estrategias de logro académico</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='EL'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </SlidePage>
                  </Slide>
                );
              })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#5ea763'>
            <SlidePage isFullCover>
              <div className='title-page'>
                <div className='logo-big'>
                  <img
                    style={{ marginTop: 150 }}
                    src={VocationJuniorLogoWhite}
                    alt='vocation-junior logo'
                  />
                </div>
              </div>
            </SlidePage>
          </Slide>
        </Deck>
      </Fragment>
    </ThemeProvider>
  );
};

export default VocationJunior;

// const vocationJuniorDummy = {
//   school: 'Colegio Vocation Junior',
//   grade: '2°A',
//   name: 'Nombre(s)',
//   lastname: 'Apellido(s)',
//   email: '',
//   RUT: '99.999.999-9',
//   BIRTH: '2004/06/09 0:00:00',
//   SEX: 'Femenino',
//   age: '16',
//   updatedat: 'Wed, 18 Nov 2020 18:34:26 GMT',
//   TOP_DIM_1: 'CN',
//   TOP_DIM_2: 'LM',
//   CONS_AL: '-25',
//   CONS_SE: '21.875',
//   CONS_IP: '12.5',
//   CONS_LM: '-15.625',
//   CONS_AP: '25',
//   CONS_CD: '-21.875',
//   CONS_FM: '-12.5',
//   CONS_CN: '15.625',
//   perc_AL_SUM: '18.75',
//   perc_AP_SUM: '43.75',
//   perc_CD_SUM: '37.5',
//   perc_CN_SUM: '87.5',
//   perc_FM_SUM: '34.375',
//   perc_IP_SUM: '46.875',
//   perc_LM_SUM: '71.875',
//   perc_SE_SUM: '59.375',
//   perc_A_F: '50',
//   perc_A_HGC: '44.44444444',
//   perc_A_LL: '50',
//   perc_B_CBS: '100',
//   perc_B_CD: '100',
//   perc_B_M: '61.11111111',
//   perc_C_AI: '0',
//   perc_C_AV: '22.22222222',
//   perc_C_D: '22.22222222',
//   A: '48.14814815',
//   B: '87.03703704',
//   C: '14.81481481'
// };
